import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dnl-demo-ng6-lib',
  template: `
    <p>
      Rajwinder's demo-ng6-lib works!
    </p>
  `,
  styles: []
})
export class DemoNg6LibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
